export default __webpack_public_path__ + "static/media/bannerf.c3ef0730.jpeg";